import { createGlobalStyle } from "styled-components"

import fontWoffHalis from "../fonts/halisr-extralight-webfont.woff"
import fontWoff2Halis from "../fonts/halisr-extralight-webfont.woff2"

import fontWoff2Sans from "../fonts/OpenSans-regular.woff2"
import fontWoff2SansSemiBold from "../fonts/OpenSans-semibold.woff2"
import fontWoff2SansBold from "../fonts/OpenSans-bold.woff2"

// Source: https://fonts.googleapis.com/css?family=Open+Sans&display=swap
export const GlobalTypographyStyles = createGlobalStyle`
  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('Open Sans'), local('OpenSans-Regular'), url(${fontWoff2Sans}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-stretch: 100%;
    font-display: swap;
    src: local('Open Sans'), local('Open Sans'), url(${fontWoff2SansSemiBold}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-stretch: 100%;
    font-display: swap;
    src: local('Open Sans'), local('OpenSans-Bold'), url(${fontWoff2SansBold}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Halis Extralight';
    src: url(${fontWoff2Halis}) format('woff2'),
      url(${fontWoffHalis}) format('woff');
    font-weight: normal;
    font-style: normal;
  }
  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
  }
  html, body {
    font-family: "Open Sans";
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: "Open Sans";
  }
  a, a::visited, a:hover {
    color: rgb(70, 146, 192);
  }
`

const halisrExtraLight = {
  fontFamily: "Halis Extralight",
  fontStyle: "normal",
  fontWeight: "normal",
  src: `url(${fontWoff2Halis}) format('woff2'),
      url(${fontWoffHalis}) format('woff')`
}

const openSans = {
  fontFamily: "Open Sans",
  fontStyle: "normal",
  fontWeight: 400,
  fontDisplay: "swap",
  src: `local('Open Sans Regular'), local('OpenSans-Regular'), url(${fontWoff2Sans}) format('woff2')`,
  unicodeRange: `U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD`
}

export const typographyGamma = {
  h1: {
    fontFamily: "'Halis Extralight'",
    fontWeight: "normal",
    fontSize: "3rem"
  },
  h2: {
    fontFamily: "'Halis Extralight'",
    fontWeight: "normal",
    fontSize: "2.6rem"
  },
  h3: {
    fontFamily: "'Halis Extralight'",
    fontWeight: "normal",
    fontSize: "2rem"
  },
  h4: {
    fontFamily: "'Halis Extralight'",
    fontWeight: "normal",
    fontSize: "1.5rem",
    textTransform: "uppercase"
  },
  h5: {
    fontFamily: "'Halis Extralight'",
    fontWeight: "normal",
    fontSize: "1.5rem"
  },
  h6: {
    fontFamily: "'Halis Extralight'",
    fontWeight: "normal",
    fontSize: "1.5rem"
  },
  fontFamily: '"Open Sans","Helvetica Neue","Arial"',
  fontWeightRegular: "normal"
}

export const typographyDefault = {
  h1: {
    fontFamily: '"Open Sans","Helvetica Neue","Arial"',
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: "2.5rem"
  },
  h2: {
    fontFamily: '"Open Sans","Helvetica Neue","Arial"',
    fontWeight: 600,
    fontSize: "1.5rem",
    lineHeight: "2rem"
  },
  h3: {
    fontFamily: '"Open Sans","Helvetica Neue","Arial"',
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "1.75rem"
  },
  h4: {
    fontFamily: '"Open Sans","Helvetica Neue","Arial"',
    fontWeight: 600,
    fontSize: "1.125rem",
    lineHeight: "1.5rem"
  },
  h5: {
    fontFamily: '"Open Sans","Helvetica Neue","Arial"',
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.5rem"
  },
  h6: {
    fontFamily: '"Open Sans","Helvetica Neue","Arial"',
    fontWeight: 600,
    fontSize: "0.875rem",
    lineHeight: "1.125rem"
  },
  fontFamily: '"Open Sans","Helvetica Neue","Arial"',
  fontWeightRegular: "normal"
}

export const fontFacesDefault = [openSans, halisrExtraLight]
export const fontFaces = fontFacesDefault
